module.exports = __webpack_public_path__ + "media/images/email_templates/message_from_editor_thumbnail-dfcaf24a0b47bff5831510825f6af55a.png";